import { CKPicker } from '@clearkit/react';
import uniq from 'lodash/uniq';

import FieldLabel from '../../components/FieldLabel';

const EventTypePicker = ({ selectedEventType, options, onChange, error }) => {
  const [eventTypeOptions, setEventTypeOptions] = useState([
    { label: selectedEventType, value: selectedEventType },
  ]);

  useEffect(() => {
    const newOptions = options.map((eventType) => ({
      label: eventType,
      value: eventType,
    }));

    setEventTypeOptions(uniq([...eventTypeOptions, ...newOptions]));
  }, [options]);

  return (
    <>
      <FieldLabel for="eventType-input" label="Event type *" />
      <CKPicker
        id="eventType"
        isCreateable
        items={eventTypeOptions}
        variant={error ? 'error' : null}
        placeholder="Choose conversion event type"
        selectedItem={{ label: selectedEventType, value: selectedEventType }}
        itemToString={(item) => item.label}
        onSelectedItemChange={({ inputValue }) => {
          onChange(inputValue);
        }}
        onCreateItem={(option) => {
          if (option) {
            setEventTypeOptions([...eventTypeOptions, option]);
            onChange(option.value);
          }
        }}
      />
    </>
  );
};

export default EventTypePicker;
